// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"246":"f6695d12","379":"3578d9ee","443":"0267565d","967":"d9dc4ac7"}[chunkId] + ".css";
};